var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _c("div", { staticClass: "row justify-content-center" }, [
      _c("div", { staticClass: "col-12 col-md-4" }, [
        !_vm.isRequestingOtp
          ? _c(
              "form",
              {
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    return _vm.requestOtp.apply(null, arguments)
                  }
                }
              },
              [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { attrs: { for: "tel" } }, [
                    _vm._v("กรุณากรอกเบอร์โทรศัพท์ของคุณ")
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.tel,
                        expression: "tel"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { type: "number", id: "tel", required: "" },
                    domProps: { value: _vm.tel },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.tel = $event.target.value
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: { type: "submit", disabled: _vm.loading }
                    },
                    [_vm._v("SUBMIT")]
                  )
                ])
              ]
            )
          : _c(
              "form",
              {
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    return _vm.submitOtp.apply(null, arguments)
                  }
                }
              },
              [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { attrs: { for: "otp_input" } }, [
                    _vm._v("กรุณากรอกรหัส OTP")
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.otp,
                        expression: "otp"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text", id: "otp_input", required: "" },
                    domProps: { value: _vm.otp },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.otp = $event.target.value
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: { type: "submit", disabled: _vm.loading }
                    },
                    [_vm._v("SUBMIT")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-success float-right",
                      attrs: { type: "button", disabled: !_vm.isTimeout },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.requestOtp.apply(null, arguments)
                        }
                      }
                    },
                    [_vm._v("ขอรหัสใหม่\n          ")]
                  )
                ]),
                _vm._v(" "),
                _c("h4", [_vm._v("Countdown: " + _vm._s(_vm.timerDisplay))])
              ]
            )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e0ee0306", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e0ee0306","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/serviceRequest/Components/LoginServiceTeam.vue
// module id = 2041
// module chunks = 0